import { Component, Input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChipDropdownComponent } from '../../../../../shared/payee-cases/chip-dropdown/chip-dropdown.component';
import { PayeeFormFieldComponent } from '../../../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';

@Component({
  selector: 'app-invoice-number-filter',
  templateUrl: './invoice-number-filter.component.html',
  styleUrls: ['./invoice-number-filter.component.scss'],
  imports: [
    ChipDropdownComponent,
    PayeeFormFieldComponent,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class InvoiceNumberFilterComponent {
  @Input({ required: true }) control!: FormControl<string | null>;

  dropdownOpen = false;

  closeAfterPaste(): void {
    setTimeout(() => (this.dropdownOpen = false));
  }
}
